export const STEPPER_META_STORAGE_KEY = 'stepperMeta';
